export default function useCustomInputs() {
	const checkIsGroupCheckbox = (key: string): boolean => {
		return key.split(';').length > 1;
	};

	const handleSplitGroupCheckbox = (key: string, value: boolean) => {
		const values: string[] = [];
		const keys = key.split(';');
		for (const subKey of keys) {
			values.push(subKey);
		}
		return values;
	};

	return {
		handleSplitGroupCheckbox,
		checkIsGroupCheckbox,
	};
}
